var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"copyright"},[_vm._v(" © Liscio Apps, LLC. All rights reserved. "),_c('br'),_c('made-with-love'),_c('terms'),_c('br'),_c('version')],1)}
var staticRenderFns = []

export { render, staticRenderFns }